module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.messageNotice.selectAuth) ? _c('div', {
    attrs: {
      "id": "messageNoticeList"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "size": "mini",
      "inline": true,
      "label-position": _vm.position
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "发布者"
    },
    model: {
      value: (_vm.searchForm.createUserName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "createUserName", $$v)
      },
      expression: "searchForm.createUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "发布时间"
    },
    model: {
      value: (_vm.searchForm.noticeTime),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "noticeTime", $$v)
      },
      expression: "searchForm.noticeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.searchSubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAdd
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 10
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.messageNoticeList,
      "border": "",
      "fit": true,
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createUserName",
      "label": "发布者",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "formatter": _vm.resolvingDate,
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "memo",
      "label": "备注",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isNew",
      "label": "是否为最新",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.isNew === 1 ? 'success' : 'danger',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.isNew == 1 ? '是' : '否') + "\n            ")])]
      }
    }], null, false, 3741944238)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopy(scope.$index, scope.row)
            }
          }
        }, [_vm._v("复制")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isNew == 1),
            expression: "scope.row.isNew==1"
          }],
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.handleClose(scope.$index, scope.row)
            }
          }
        }, [_vm._v("关闭\n            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2975050172)
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "align": "left",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "公告信息",
      "visible": _vm.dialogFormVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.messageNoticeInfo,
      "required-asterisk": "",
      "label-width": "auto",
      "label-position": _vm.position,
      "center": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.messageNoticeInfo.title),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "title", $$v)
      },
      expression: "messageNoticeInfo.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.messageNoticeInfo.tag),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "tag", $$v)
      },
      expression: "messageNoticeInfo.tag"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.messageNoticeInfo.memo),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "memo", $$v)
      },
      expression: "messageNoticeInfo.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#909399"
    },
    model: {
      value: (_vm.messageNoticeInfo.isNew),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "isNew", $$v)
      },
      expression: "messageNoticeInfo.isNew"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布者"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.messageNoticeInfo.createUserName),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "createUserName", $$v)
      },
      expression: "messageNoticeInfo.createUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "发布时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "required": "",
      "type": "datetime",
      "placeholder": "发布时间"
    },
    model: {
      value: (_vm.messageNoticeInfo.noticeTime),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "noticeTime", $$v)
      },
      expression: "messageNoticeInfo.noticeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.messageNoticeInfo.content),
      callback: function($$v) {
        _vm.$set(_vm.messageNoticeInfo, "content", $$v)
      },
      expression: "messageNoticeInfo.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("发布")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-01af4d12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/systemSet/messageNotice.vue
// module id = 1569
// module chunks = 0